import React from "react";
import { Link } from "react-router-dom";
import Navbar from "../components/Navbar";

function Home() {
  return (

    <>

    
<div className="home-container">
      {/* Hero Section */}
      <header className="hero-section">
        <div className="hero-content">
          <h1>Welcome to Sunev</h1>
          <p>A technology brand dedicated to knowledge exploration and innovation.</p>
        </div>
      </header>

      {/* Product Section */}
      <section className="products-section">
        <h2>Our Products</h2>
        <div className="products-grid">
          {/* FlowRead Entry */}
          <Link to="/FlowRead" className="product-card">
            <img src="/assets/ic_launcher1.png" alt="FlowRead Logo" className="product-icon" />
            <h3>📖 FlowRead</h3>
            <p>Smart booklist management to enhance your learning experience.</p>
          </Link>

          {/* Future Products */}
          <div className="product-card coming-soon">
            <h3>🚀 Coming Soon</h3>
            <p>Exciting new products are on the way. Stay tuned!</p>
          </div>
        </div>
      </section>
    </div>
    </>
  );
}

export default Home;
